import React from "react";
import { ReactComponent as LogoutIcon } from "../../../assets/icons/LogoutIcon.svg";
import MenuItem from "./MenuItems";

const AnonymousMenu = ({ handleLogout }) => {
  return (
    <div className="container-fluid">
      <div style={{ marginTop: "40rem" }}>
        <MenuItem
          icon={LogoutIcon}
          onClick={handleLogout}
          href={""}
          text={"Logout"}
        >
          <LogoutIcon />
        </MenuItem>
      </div>
    </div>
  );
};

export default AnonymousMenu;
